import { DocumentDesign } from "../../api/types";
import { DocumentDesignState } from "../../canvas/state/types";
import { CanvasPaperConfig } from "./PageDesigner";

export function getPartialDocument(
  documentDesign: DocumentDesign,
  state: DocumentDesignState,
  canvasPaperConfig: CanvasPaperConfig,
): Partial<DocumentDesign> {
  return {
    id: documentDesign.id,
    name: documentDesign.name,
    canvas_template: state,
    paper_config: {
      paper_size: JSON.stringify({
        height: canvasPaperConfig.height,
        width: canvasPaperConfig.width,
      }),
      orientation: canvasPaperConfig.orientation ?? "portrait",
      background_style: "blank",
      padding_directions: JSON.stringify(canvasPaperConfig.paddingDirections),
      page_break_margin: canvasPaperConfig.pageBreakMargin,
    },
  };
}
